import React from 'react';
import ListOfResource from "./Components/JS/ListOfResource";
import Header from "./Components/JS/Header";
import Footer from "./Components/JS/Footer";


// ІМПОРТУЄМО СТИЛІ
import './Components/CSS/App.css';

export default function App() {
    return (
        <div className="app-wrapper">
            <Header/>

            <main className="main-content">
                <ListOfResource/>
            </main>

            <Footer/>
        </div>
    )
}